var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20.571,
    viewBox: "0 0 18 20.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-svgrepo-com",
    transform: "translate(-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13847",
    "data-name": "Path 13847",
    d: "M97.286,0A1.289,1.289,0,0,0,96,1.286v18a1.289,1.289,0,0,0,1.286,1.286h12.857a1.289,1.289,0,0,0,1.286-1.286V5.143L106.286,0Z",
    transform: "translate(-61.429)",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13848",
    "data-name": "Path 13848",
    d: "M353.286,5.143h3.857L352,0V3.857A1.289,1.289,0,0,0,353.286,5.143Z",
    transform: "translate(-307.143)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13849",
    "data-name": "Path 13849",
    d: "M387.857,131.857,384,128h3.857Z",
    transform: "translate(-337.857 -122.857)",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13850",
    "data-name": "Path 13850",
    d: "M47.429,247.071a.645.645,0,0,1-.643.643H32.643a.645.645,0,0,1-.643-.643v-6.429a.645.645,0,0,1,.643-.643H46.786a.645.645,0,0,1,.643.643Z",
    transform: "translate(0 -230.357)",
    fill: "#f15642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7770",
    "data-name": "Group 7770",
    transform: "translate(34.802 11.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13851",
    "data-name": "Path 13851",
    d: "M101.744,294.675a.354.354,0,0,1,.349-.355h1.187a1.285,1.285,0,0,1,0,2.57h-.858v.679a.323.323,0,0,1-.329.354.346.346,0,0,1-.349-.354Zm.678.293v1.281h.858a.641.641,0,0,0,0-1.281Z",
    transform: "translate(-101.744 -294.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13852",
    "data-name": "Path 13852",
    d: "M188.179,299.029a.322.322,0,0,1-.355-.318v-2.92a.35.35,0,0,1,.355-.319h1.177a1.779,1.779,0,0,1,.046,3.557Zm.324-2.929v2.3h.853a1.155,1.155,0,0,0,0-2.3Z",
    transform: "translate(-184.365 -295.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13853",
    "data-name": "Path 13853",
    d: "M287.808,296.125v.817h1.311a.4.4,0,0,1,.37.364.357.357,0,0,1-.37.309h-1.311v1.079a.3.3,0,0,1-.308.318.327.327,0,0,1-.365-.318v-2.92a.325.325,0,0,1,.365-.319h1.8a.321.321,0,0,1,.36.319.355.355,0,0,1-.36.35h-1.5Z",
    transform: "translate(-279.687 -295.41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13854",
    "data-name": "Path 13854",
    d: "M108.214,416.643H96v.643h12.214a.645.645,0,0,0,.643-.643V416A.645.645,0,0,1,108.214,416.643Z",
    transform: "translate(-61.429 -399.286)",
    fill: "#cad1d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.c04eec39c27d68e2915eda8758439cc6.svg";
export { ForwardRef as ReactComponent };